import React, { memo } from 'react';
import { Flex } from 'antd-mobile';
import { AsymmetricGrid, HorizontalGrid, SymmetricGrid } from './components';

const RecommandCell = memo((props) => {
  const {
    combinationType, // 0: 对称宫格 1: 横向宫格 2: 不对称宫格1 3: 不对称宫格2
    containerStyle // 容器样式
  } = props;

  const renderItem = () => {
    switch (combinationType) {
      case 0:
        return <SymmetricGrid {...props} />;
      case 1:
        return <HorizontalGrid {...props} />;
      case 2:
      case 3:
        return <AsymmetricGrid {...props} />;
    }
  };

  return <Flex style={containerStyle}>{renderItem()}</Flex>;
});

export default RecommandCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/RecommandCell/index.js